import { render, staticRenderFns } from "./dictionaryList.vue?vue&type=template&id=f459ba3a&scoped=true&"
import script from "./dictionaryList.vue?vue&type=script&lang=js&"
export * from "./dictionaryList.vue?vue&type=script&lang=js&"
import style0 from "./dictionaryList.vue?vue&type=style&index=0&id=f459ba3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f459ba3a",
  null
  
)

export default component.exports